import { createFileRoute, redirect } from '@tanstack/react-router'
import { BudgetGridScreen } from '@/features/accounting-budgets/budget-grid-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for editing one budget.
 *
 * The grant guard is `accounting_budget.view` — seeing the grid is a read;
 * `accounting_budget.edit` gates the PATCH itself server-side, so a
 * view-only user reaches a grid whose save the API refuses, same as any
 * other document screen in this module.
 */
export const Route = createFileRoute('/_authenticated/accounting/budgets/$budgetId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_budget.view')) {
      throw redirect({ to: '/accounting/budgets' })
    }
  },
  component: AccountingBudgetDetailRoute,
})

function AccountingBudgetDetailRoute() {
  const { budgetId } = Route.useParams()

  return <BudgetGridScreen budgetId={budgetId} />
}
